import { LucideIcon } from 'lucide-react';
import { ActionButtonBase } from './ActionButtonBase';

interface AnimatedIconButtonProps {
  icon: LucideIcon;
  label?: string;
  onClick?: () => void;
  variant?: 'default' | 'success' | 'danger' | 'secondary' | 'neutral';
  disabled?: boolean;
  loading?: boolean;
  className?: string;
  iconClassName?: string;
  size?: 'default' | 'mini' | 'lg';
  borderColor?: string;
  hoverBgColor?: string;
  iconColor?: string;
  textColorOnHover?: string;
  revealLabelOnHover?: boolean;
  expanded?: boolean;
  title?: string;
  type?: 'button' | 'submit' | 'reset';
  testId?: string;
  /** V4-ACCOUNT-03 2026-05-29 — explicit aria-label when label is hidden / iconographic */
  ariaLabel?: string;
}

export function AnimatedIconButton({
  icon: Icon,
  label,
  onClick,
  variant = 'default',
  disabled = false,
  loading = false,
  className = '',
  iconClassName = '',
  size = 'default',
  borderColor,
  hoverBgColor,
  iconColor,
  textColorOnHover,
  revealLabelOnHover = true,
  expanded = false,
  title,
  type = 'button',
  testId,
  ariaLabel,
}: AnimatedIconButtonProps) {
  return (
    <ActionButtonBase
      icon={Icon}
      label={label}
      onClick={onClick}
      variant={variant}
      disabled={disabled}
      loading={loading}
      className={className}
      iconClassName={iconClassName}
      size={size}
      borderColor={borderColor}
      hoverBgColor={hoverBgColor}
      iconColor={iconColor}
      textColorOnHover={textColorOnHover}
      revealLabelOnHover={revealLabelOnHover}
      expanded={expanded}
      title={title}
      type={type}
      testId={testId}
      ariaLabel={ariaLabel}
    />
  );
}
